import logo from './logo.svg';
import './App.css';

import { Abouts, Header, Skills, Testimonials, Work, Footer } from './container'
import Navbar from './components/Navbar/Navbar';
import './App.scss'

function App() {
  return (
    <div className='app'>
     
      <div>
      <Header/>
      <Abouts/>
      <Work/>
      <Skills/>
      {/* <Testimonials/> */}
      <Footer/>
     
      </div>
    </div>
  );
}

export default App;
